import { render, staticRenderFns } from "./ResetToNewPasswordFormComponent.vue?vue&type=template&id=69b5e58d&scoped=true&"
import script from "./ResetToNewPasswordFormComponent.vue?vue&type=script&lang=ts&"
export * from "./ResetToNewPasswordFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResetToNewPasswordFormComponent.vue?vue&type=style&index=0&id=69b5e58d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b5e58d",
  null
  
)

export default component.exports